var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArcanaElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 45,
    viewBox: "0 0 51 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3488 44.3521C37.3324 44.3521 47.047 34.6374 47.047 22.6538C47.047 10.6702 37.3324 0.955566 25.3488 0.955566C13.3652 0.955566 3.65051 10.6702 3.65051 22.6538C3.65051 34.6374 13.3652 44.3521 25.3488 44.3521Z",
    fill: "url(#paint0_linear_221_35104)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3495 0C12.931 0 2.86658 10.0644 2.86658 22.4829C2.86658 34.9014 12.931 44.9659 25.3495 44.9659C37.768 44.9659 47.8325 34.9014 47.8325 22.4829C47.8325 10.0644 37.768 0 25.3495 0ZM25.3495 43.7377C19.6861 43.7377 14.3639 41.5201 10.3381 37.5284C6.31237 33.5027 4.1289 28.1804 4.1289 22.5171C4.1289 16.8537 6.34649 11.5315 10.3381 7.50569C14.3298 3.47991 19.6861 1.29644 25.3495 1.29644C31.0129 1.29644 36.3351 3.51403 40.3609 7.50569C44.3867 11.5315 46.5701 16.8537 46.5701 22.5171C46.5701 28.1804 44.3526 33.5027 40.3609 37.5284C36.3692 41.5201 31.0129 43.7377 25.3495 43.7377Z",
    fill: "url(#paint1_linear_221_35104)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.3482 44.386C15.1814 44.386 6.58395 37.7674 3.71814 28.6582C6.37925 38.1085 15.079 45.0001 25.3482 45.0001C35.6173 45.0001 44.3171 38.0744 46.9782 28.6582C44.1124 37.7674 35.515 44.386 25.3482 44.386Z",
    fill: "url(#paint2_linear_221_35104)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8031 7.06239C36.675 2.93426 31.1822 0.648438 25.3482 0.648438C19.5142 0.648438 14.0556 2.93426 9.92744 7.06239C5.79931 11.1905 3.51349 16.6492 3.51349 22.4832C3.51349 28.3171 5.79931 33.8099 9.89332 37.9039C14.0215 42.0321 19.5142 44.2838 25.3141 44.2838C31.1139 44.2838 36.6409 41.9979 40.7349 37.9039C44.863 33.7758 47.1147 28.283 47.1147 22.4832C47.1147 16.6833 44.8971 11.1905 40.8031 7.06239ZM40.3596 37.4945C36.3338 41.5203 31.0116 43.7038 25.3482 43.7038C19.6848 43.7038 14.3626 41.4862 10.3368 37.4945C6.31106 33.4688 4.12759 28.1465 4.12759 22.4832C4.12759 16.8198 6.34518 11.4976 10.3368 7.47179C14.3285 3.44601 19.6848 1.26254 25.3482 1.26254C31.0116 1.26254 36.3338 3.48013 40.3596 7.47179C44.3854 11.4976 46.5688 16.8198 46.5688 22.4832C46.5688 28.1465 44.3854 33.5029 40.3596 37.4945Z",
    fill: "url(#paint3_linear_221_35104)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.0123 16.3419C44.3171 6.9257 35.6514 0 25.3482 0C15.0449 0 6.37925 6.9257 3.71814 16.3419C6.61806 7.23275 15.1814 0.682335 25.3482 0.682335C35.515 0.682335 44.1124 7.23275 47.0123 16.3419Z",
    fill: "url(#paint4_linear_221_35104)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.19867 33.7422L7.77865 35.448C7.77865 35.448 7.91512 35.9257 7.6763 36.4033L9.00686 37.9385L8.83627 35.8233C8.87039 35.8574 7.19867 33.7422 7.19867 33.7422Z",
    fill: "url(#paint5_linear_221_35104)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20987 6.14154C8.22049 9.48498 6.75347 12.112 6.75347 12.112C6.4123 12.8625 5.96878 13.8519 5.96878 13.8519C5.76408 14.2613 5.42291 15.1484 5.42291 15.1484C6.37818 14.0907 7.0264 13.1696 7.74285 12.1802C9.17576 10.3038 10.131 7.02857 10.6087 5.11803C10.8134 4.231 10.9498 3.6169 10.9498 3.6169C11.7686 3.20749 12.2121 2.96868 12.2463 2.93456C12.3145 2.90044 12.4168 2.86633 12.4851 2.83221C12.1439 2.38869 11.7345 2.04752 11.7345 2.04752C10.4722 1.84282 9.92632 2.55928 9.92632 2.55928C9.85809 3.20749 9.75574 3.8216 9.61927 4.40158C9.48281 5.0498 9.34634 5.62978 9.20987 6.14154Z",
    fill: "url(#paint6_linear_221_35104)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93451 13.8518C5.93451 13.8518 6.65096 12.2483 6.68508 12.1801C6.68508 12.1801 8.18622 9.48489 9.1756 6.14145C9.34618 5.59558 9.48265 5.04971 9.61912 4.46973C9.61912 4.46973 9.89205 8.93902 5.93451 13.8518Z",
    fill: "url(#paint7_linear_221_35104)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.714 5.42505C10.714 5.42505 10.5434 5.59563 10.0999 7.02854C10.0999 7.02854 10.2705 5.01565 10.7822 3.41216C10.7822 3.41216 11.3281 2.38866 11.7716 2.11572C11.8399 2.18396 12.3516 2.52512 13.1363 3.61686C13.0681 3.65098 12.8293 3.82156 12.761 3.88979C12.6587 3.92391 11.874 4.46978 10.714 5.42505Z",
    fill: "url(#paint8_linear_221_35104)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.92828 2.62831C9.92828 2.62831 10.3718 2.01421 11.4635 2.08244C11.02 2.73066 10.133 2.86713 9.92828 2.62831Z",
    fill: "url(#paint9_linear_221_35104)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7105 5.42531L11.0517 4.47004C11.4952 3.89006 12.0069 3.58301 12.0069 3.58301C12.0069 3.58301 12.4505 3.65124 12.894 3.78771L12.7575 3.89006C11.6658 4.57239 10.7105 5.42531 10.7105 5.42531Z",
    fill: "url(#paint10_linear_221_35104)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.17458 14.2619C6.17458 14.2619 6.44751 13.5454 6.65221 12.8972L6.95926 11.7031C6.92515 11.7714 6.78868 12.0784 6.72045 12.1125C6.17458 13.2043 5.86753 13.9207 5.38989 15.1489C5.42401 15.1489 5.96988 14.5007 6.17458 14.2619Z",
    fill: "url(#paint11_linear_221_35104)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51403 17.0593C3.51403 17.0593 1.94466 18.6969 1.0235 22.4838H0C0 22.4838 0.238817 18.3216 4.23048 14.7734L3.51403 17.0593Z",
    fill: "url(#paint12_linear_221_35104)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20987 38.8247C8.22049 35.4813 6.75347 32.8543 6.75347 32.8543C6.4123 32.1037 5.96878 31.1143 5.96878 31.1143C5.76408 30.7049 5.42291 29.8179 5.42291 29.8179C6.37818 30.8755 7.0264 31.7966 7.74285 32.786C9.17576 34.6283 10.131 37.9377 10.6087 39.8482C10.8134 40.7352 10.9498 41.3493 10.9498 41.3493C11.7686 41.7587 12.2121 41.9976 12.2463 42.0317C12.3145 42.0658 12.4168 42.0999 12.4851 42.134C12.1439 42.5775 11.7345 42.9187 11.7345 42.9187C10.4722 43.1234 9.92632 42.407 9.92632 42.407C9.85809 41.7587 9.75574 41.1446 9.61927 40.5646C9.48281 39.9164 9.34634 39.3706 9.20987 38.8247Z",
    fill: "url(#paint13_linear_221_35104)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93451 31.1152C5.93451 31.1152 6.65096 32.7187 6.68508 32.787C6.68508 32.787 8.18622 35.4822 9.1756 38.8256C9.34618 39.3715 9.48265 39.9174 9.61912 40.4973C9.61912 40.4973 9.89205 36.0622 5.93451 31.1152Z",
    fill: "url(#paint14_linear_221_35104)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5753 39.4392C10.5753 39.4392 10.5412 39.4051 10.0636 37.9722C10.0636 37.9722 10.2342 39.9851 10.7459 41.5885C10.7459 41.5885 11.2918 42.612 11.7353 42.885C11.8036 42.8167 12.8953 41.8615 13.2023 41.4521C13.1341 41.418 12.6224 41.0427 12.5541 41.0086C12.52 40.9744 11.5647 40.3603 10.5753 39.4392Z",
    fill: "url(#paint15_linear_221_35104)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92828 42.373C9.92828 42.373 10.3718 42.9871 11.4635 42.9189C11.02 42.2707 10.133 42.1001 9.92828 42.373Z",
    fill: "url(#paint16_linear_221_35104)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5752 39.4395L10.8481 40.2241C11.0528 40.9406 11.5646 41.4865 11.5646 41.4865C11.5646 41.4865 11.9399 41.5547 12.2469 41.3841L12.6563 41.0771C12.4857 40.9747 11.2916 40.0536 10.5752 39.4395Z",
    fill: "url(#paint17_linear_221_35104)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.17458 30.7393C6.17458 30.7393 6.44751 31.4558 6.65221 32.104L6.95926 33.2981C6.92515 33.2299 6.78868 32.9228 6.72045 32.8887C6.17458 31.797 5.86753 31.0805 5.38989 29.8523C5.42401 29.8182 5.96988 30.5005 6.17458 30.7393Z",
    fill: "url(#paint18_linear_221_35104)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51403 27.908C3.51403 27.908 1.94466 26.2704 1.0235 22.4834H0C0 22.4834 0.238817 26.6456 4.23048 30.1938L3.51403 27.908Z",
    fill: "url(#paint19_linear_221_35104)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02335 22.4837C1.91038 18.7991 3.51387 17.0591 3.51387 17.0591L3.92327 15.7627C0.989231 18.5603 0.511597 22.5178 0.511597 22.5178C0.511597 22.5178 0.989231 26.4754 3.92327 29.2388L3.51387 27.9424C3.51387 27.9083 1.91038 26.1683 1.02335 22.4837Z",
    fill: "url(#paint20_linear_221_35104)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.17188 27.4644C3.17188 27.4644 3.30834 28.2149 3.27423 28.5561L3.51304 29.5455L4.22949 30.2278L3.92244 29.2384L3.51304 27.942L3.17188 27.4644Z",
    fill: "url(#paint21_linear_221_35104)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.22949 14.7729L3.92244 15.7623L3.51304 17.0588L3.17188 17.5364V16.547L3.92244 15.0459L4.22949 14.7729Z",
    fill: "url(#paint22_linear_221_35104)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.499 33.7422L42.919 35.448C42.919 35.448 42.7825 35.9257 43.0213 36.4033L41.6908 37.9385L41.8614 35.8233C41.8614 35.8574 43.499 33.7422 43.499 33.7422Z",
    fill: "url(#paint23_linear_221_35104)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5172 6.14202C42.5065 9.48547 43.9736 12.1125 43.9736 12.1125C44.3147 12.863 44.7582 13.8524 44.7582 13.8524C44.9629 14.2618 45.3041 15.1488 45.3041 15.1488C44.3488 14.0912 43.7006 13.1701 42.9842 12.1807C41.5513 10.3043 40.596 7.02906 40.1184 5.11852C39.8795 4.23149 39.7772 3.61738 39.7772 3.61738C38.9584 3.20798 38.5149 2.96917 38.4808 2.93505C38.4125 2.90093 38.3443 2.86681 38.2419 2.8327C38.5831 2.38918 38.9925 2.04801 38.9925 2.04801C40.2548 1.84331 40.8007 2.55976 40.8007 2.55976C40.8689 3.20798 40.9713 3.82208 41.1078 4.40207C41.2101 5.05029 41.3466 5.63027 41.5172 6.14202Z",
    fill: "url(#paint24_linear_221_35104)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7592 13.8523C44.7592 13.8523 44.0427 12.2488 44.0086 12.1806C44.0086 12.1806 42.5075 9.48538 41.5181 6.14194C41.3475 5.59607 41.211 5.0502 41.0746 4.47021C41.0746 4.47021 40.8016 8.93951 44.7592 13.8523Z",
    fill: "url(#paint25_linear_221_35104)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9832 5.42554C39.9832 5.42554 40.1197 5.59612 40.5973 7.02902C40.5973 7.02902 40.4267 5.01614 39.915 3.41265C39.915 3.41265 39.3691 2.38914 38.9597 2.11621C38.8915 2.18444 38.3797 2.52561 37.595 3.61735C37.6633 3.65147 37.9021 3.82205 37.9703 3.89028C38.0386 3.9244 38.8232 4.47027 39.9832 5.42554Z",
    fill: "url(#paint26_linear_221_35104)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40.7674 2.62831C40.7674 2.62831 40.3239 2.01421 39.2321 2.08244C39.6756 2.73066 40.5627 2.86713 40.7674 2.62831Z",
    fill: "url(#paint27_linear_221_35104)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9832 5.42531L39.642 4.47004C39.1985 3.89006 38.6867 3.58301 38.6867 3.58301C38.6867 3.58301 38.2432 3.65124 37.7997 3.78771L37.9361 3.89006C39.0279 4.57239 39.9832 5.42531 39.9832 5.42531Z",
    fill: "url(#paint28_linear_221_35104)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.5222 14.2624C44.5222 14.2624 44.2492 13.5459 44.0445 12.8977L43.7375 11.7036C43.7716 11.7718 43.9081 12.0789 43.9763 12.113C44.5222 13.2048 44.8292 13.9212 45.3069 15.1494C45.3069 15.1494 44.7269 14.5012 44.5222 14.2624Z",
    fill: "url(#paint29_linear_221_35104)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1803 17.0597C47.1803 17.0597 48.7496 18.6974 49.6708 22.4843H50.6943C50.6943 22.4843 50.4555 18.3221 46.4638 14.7739L47.1803 17.0597Z",
    fill: "url(#paint30_linear_221_35104)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5209 38.8262C42.5103 35.4827 43.9773 32.8557 43.9773 32.8557C44.3184 32.1052 44.762 31.1158 44.762 31.1158C44.9667 30.7064 45.3078 29.8193 45.3078 29.8193C44.3526 30.877 43.7043 31.7981 42.9879 32.7875C41.555 34.6298 40.5997 37.9391 40.1221 39.8497C39.8833 40.7367 39.7809 41.3508 39.7809 41.3508C38.9621 41.7602 38.5186 41.999 38.4845 42.0331C38.4163 42.0673 38.348 42.1014 38.2457 42.1355C38.5868 42.579 38.9962 42.9202 38.9962 42.9202C40.2586 43.1249 40.8044 42.4084 40.8044 42.4084C40.8727 41.7602 40.975 41.1461 41.1115 40.5661C41.2138 39.9179 41.3503 39.372 41.5209 38.8262Z",
    fill: "url(#paint31_linear_221_35104)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7629 31.1157C44.7629 31.1157 44.0464 32.7192 44.0123 32.7874C44.0123 32.7874 42.5112 35.4827 41.5218 38.8261C41.3512 39.372 41.2148 39.9178 41.0783 40.4978C41.0783 40.4978 40.8054 36.0627 44.7629 31.1157Z",
    fill: "url(#paint32_linear_221_35104)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1223 39.4397C40.1223 39.4397 40.1564 39.4056 40.634 37.9727C40.634 37.9727 40.4635 39.9855 39.9517 41.589C39.9517 41.589 39.4058 42.6125 38.9964 42.8855C38.9282 42.8172 37.8365 41.862 37.5294 41.4526C37.5977 41.4184 38.1094 41.0432 38.1776 41.009C38.2118 40.9749 39.1329 40.3608 40.1223 39.4397Z",
    fill: "url(#paint33_linear_221_35104)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7711 42.3735C40.7711 42.3735 40.3276 42.9876 39.2358 42.9194C39.6794 42.2712 40.5664 42.1006 40.7711 42.3735Z",
    fill: "url(#paint34_linear_221_35104)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1221 39.4399L39.8492 40.2246C39.6445 40.9411 39.1328 41.4869 39.1328 41.4869C39.1328 41.4869 38.7575 41.5552 38.4504 41.3846L38.041 41.0775C38.2457 40.9752 39.4398 40.054 40.1221 39.4399Z",
    fill: "url(#paint35_linear_221_35104)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.5225 30.7398C44.5225 30.7398 44.2496 31.4563 44.0449 32.1045L43.7379 33.2986C43.772 33.2304 43.9084 32.9233 43.9767 32.8892C44.5225 31.7975 44.8296 31.081 45.3072 29.8528C45.3072 29.8187 44.7272 30.501 44.5225 30.7398Z",
    fill: "url(#paint36_linear_221_35104)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1852 27.9085C47.1852 27.9085 48.7546 26.2708 49.6757 22.4839H50.6992C50.6992 22.4839 50.4604 26.6461 46.4688 30.1943L47.1852 27.9085Z",
    fill: "url(#paint37_linear_221_35104)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6756 22.4842C48.7886 18.7996 47.1851 17.0596 47.1851 17.0596L46.7757 15.7632C49.7097 18.5608 50.1874 22.4842 50.1874 22.4842C50.1874 22.4842 49.7097 26.4417 46.7757 29.2052L47.1851 27.9087C47.1851 27.9087 48.7886 26.1688 49.6756 22.4842Z",
    fill: "url(#paint38_linear_221_35104)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.5574 27.4648C47.5574 27.4648 47.421 28.2154 47.4551 28.5566L47.2163 29.546L46.4998 30.2283L46.8069 29.2389L47.2163 27.9425L47.5574 27.4648Z",
    fill: "url(#paint39_linear_221_35104)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.4668 14.7729L46.7739 15.7623L47.1833 17.0588L47.5585 17.5364V16.547L46.7739 15.0459L46.4668 14.7729Z",
    fill: "url(#paint40_linear_221_35104)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0455 11.0883C26.274 11.0968 28.5159 11.8247 30.3955 13.3158C34.8359 16.8386 35.5723 23.2842 32.0401 27.7127C28.5079 32.1413 22.045 32.8757 17.6046 29.3529C15.7251 27.8618 14.5096 25.8471 14 23.6833C14.3081 26.6499 15.7651 29.4958 18.2906 31.4994C23.2744 35.4532 30.5284 34.6292 34.4927 29.6587C38.4571 24.6882 37.6309 17.4536 32.6471 13.4998C30.1216 11.4963 27.0139 10.7207 24.0459 11.0883H24.0455Z",
    fill: "#BF96FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1718 29.3552L28.4053 30.0162L28.5204 29.3263L29.1718 29.3552L29.4877 29.5466L29.4495 28.7612L29.1718 29.3552Z",
    fill: "#BF96FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4877 29.5474L28.4053 30.0169L29.1718 29.356L29.4877 29.5474Z",
    fill: "#BF96FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4499 28.7612L28.5208 29.3263L29.1722 29.3552L29.4499 28.7612Z",
    fill: "#BF96FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6324 32.083L24.3666 32.3057L24.5966 33.0888L24.6324 32.083Z",
    fill: "#BF96FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6335 32.083L24.9424 32.3272L24.5977 33.0888",
    fill: "#BF96FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M19.917 29.5669L24.2346 33.0298L24.012 31.952L19.917 29.5669Z",
    fill: "#BF96FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2344 33.0298L21.0951 31.8515L19.9167 29.5669L21.5977 31.6142L24.2344 33.0298Z",
    fill: "#BF96FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0117 31.952L23.667 31.4131L19.9167 29.5669L21.5977 31.6142L21.0951 31.8515L19.9167 29.5669L21.5977 31.6142L24.2344 33.0298L24.0117 31.952Z",
    fill: "#BF96FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2346 33.0298L19.917 29.5669L24.012 31.952L24.2346 33.0298Z",
    fill: "#BF96FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M19.917 29.5669L21.598 31.6142L21.0953 31.8515L19.917 29.5669Z",
    fill: "#BF96FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6383 29.0946L26.71 28.9151L27.5004 28.6709L28.0462 28.793L27.7877 29.6408L26.933 29.5256L26.6383 29.0946Z",
    fill: "#BF96FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5009 28.6709L26.9335 29.5256L28.0467 28.793",
    fill: "#BF96FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7881 29.6409L26.0351 30.7472L26.6387 29.0947L26.9334 29.5258L26.0351 30.7472L26.9334 29.5258L27.7881 29.6409Z",
    fill: "#BF96FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9334 29.5269L26.0351 30.7483L27.7881 29.642L26.9334 29.5269Z",
    fill: "#BF96FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M31.559 31.8242L30.5013 33.1285V32.538L31.559 31.8242Z",
    fill: "#BF96FF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5002 33.1289L27.1043 33.3381L30.5002 32.5384L29.8727 31.6895L31.5579 31.8246L30.5002 32.5384V33.1289Z",
    fill: "#BF96FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1043 33.3381L29.8727 31.6895L30.5002 32.5384L27.1043 33.3381Z",
    fill: "#BF96FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1489 23.1821L23.0916 23.7568L23.3073 24.1089L23.5372 23.6062L23.1489 23.1821Z",
    fill: "#BF96FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1472 23.1821L23.2481 23.7137L23.5354 23.6062",
    fill: "#BF96FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0915 23.7555L23.2498 23.7124L23.3072 24.1076",
    fill: "#BF96FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6252 27.2122L22.7211 25.9546L23.3282 26.9006L22.9187 26.859L22.6252 27.2122Z",
    fill: "#BF96FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7211 25.9546L22.9187 26.859L23.2962 27.899L23.3282 26.9006L23.2962 27.899L22.6252 27.2122L22.9187 26.859L23.3282 26.9006",
    fill: "#BF96FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3298 26.901L22.9203 26.8594L23.2978 27.8994",
    fill: "#BF96FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1572 19.6245L23.8575 20.5474L24.1102 21.1441L24.6256 20.5151L24.1572 19.6245Z",
    fill: "#BF96FF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M24.157 19.6245L24.2868 20.2651L24.6254 20.5151L24.157 19.6245Z",
    fill: "#BF96FF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8575 20.5465L24.287 20.2642L24.1102 21.1432L23.8575 20.5465Z",
    fill: "#BF96FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9198 26.96L26.8698 27.621L27.0635 27.8721L27.2288 27.4557L26.9198 26.96Z",
    fill: "#BF96FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2288 27.4557L26.9198 26.96L27.035 27.5347L27.2288 27.4557L27.035 27.5347L26.8698 27.621L27.035 27.5347L27.0635 27.8721L26.8698 27.621L26.9198 26.96",
    fill: "#BF96FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0651 27.8725L27.2303 27.4561L27.0366 27.535L27.0651 27.8725Z",
    fill: "#BF96FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8698 27.6214L27.035 27.5352L27.0635 27.8726",
    fill: "#BF96FF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9211 26.96L27.0363 27.5347L27.23 27.4557",
    fill: "#BF96FF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0506 24.3135L26.1092 25.9143L25.8688 26.1767L25.7186 24.6235L26.056 24.7869L27.0506 24.3135Z",
    fill: "#BF96FF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M26.056 24.7863L25.9897 24.0174L25.7186 24.6229L26.056 24.7863L27.0506 24.3129L26.4508 23.4878",
    fill: "#BF96FF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0501 24.3129L26.1086 25.9137L25.8683 26.1761L26.0555 24.7863L26.4503 23.4878L25.9892 24.0174L26.0555 24.7863",
    fill: "#BF96FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1086 25.9136L26.0555 24.7861L25.8683 26.1759L26.1086 25.9136Z",
    fill: "#BF96FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5596 23.2163L28.9756 23.7051L29.0723 23.7818L29.0206 23.2629L28.9197 23.3311L28.5596 23.2163Z",
    fill: "#BF96FF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9197 23.3311L28.8916 23.0746L29.0206 23.2629L28.9197 23.3311L28.5596 23.2163L28.7044 22.9189",
    fill: "#BF96FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5596 23.2163L28.9756 23.7051L29.0723 23.7818L28.9197 23.3311L28.7044 22.9189L28.8916 23.0746L28.9197 23.3311",
    fill: "#BF96FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9748 23.7061L28.9189 23.332L29.0715 23.7827L28.9748 23.7061Z",
    fill: "#BF96FF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7326 24.3862L19.2245 24.7934L19.5766 24.6848L19.7326 24.3862Z",
    fill: "#BF96FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5771 24.6832L19.69 24.8396L20.0205 25.2991L19.8803 26.0487L19.7081 26.4832L19.5879 26.0321L19.002 25.5206L19.225 24.7918L19.7331 24.3843L19.5771 24.6832Z",
    fill: "#BF96FF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5879 26.0318L19.002 25.5202L19.341 26.1504L19.7077 26.4828L19.5879 26.0318L20.0205 25.2987L19.7327 24.3843L19.5879 26.0318Z",
    fill: "#BF96FF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7077 26.4826L19.341 26.1502L19.002 25.52L19.5879 26.0315L19.7077 26.4826Z",
    fill: "#BF96FF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0207 25.2998L19.5881 26.0328L19.7079 26.4839L19.8801 26.0498L20.0207 25.2998Z",
    fill: "#BF96FF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2245 24.7918L19.5766 24.6832L19.7326 24.3843L19.2245 24.7918Z",
    fill: "#BF96FF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7313 24.3843L19.5753 24.6832L19.6909 24.8454L19.5865 26.0318L20.0191 25.2987L19.7313 24.3843Z",
    fill: "#BF96FF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6909 24.8454L19.7313 24.3843L19.5753 24.6832",
    fill: "#BF96FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9262 28.8417L18.8907 28.4357L19.1057 28.2007L18.9262 28.8417Z",
    fill: "#BF96FF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5784 28.2764L18.7718 27.9097L19.1073 28.1997L18.7718 27.9097L18.8924 28.4347L18.5784 28.2764L18.9278 28.8407L18.8924 28.4347L19.1073 28.1997L18.8924 28.4347L18.7718 27.9097L18.8924 28.4347L19.1073 28.1997L18.7718 27.9097L18.5784 28.2764Z",
    fill: "#BF96FF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8924 28.4347L18.7718 27.9097L18.5784 28.2764L18.8924 28.4347L19.1073 28.1997Z",
    fill: "#BF96FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6388 21.1074L26.675 21.4953L27.0124 21.6532L27.2782 21.6821L26.9982 21.2584L26.6388 21.1074Z",
    fill: "#BF96FF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8896 21.3327L27.1276 21.0923L26.8896 21.3327L26.6388 21.1065L27.1276 21.0923L27.2782 21.6812",
    fill: "#BF96FF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8896 21.3327L27.1276 21.0923L26.6388 21.1065L26.8896 21.3327L26.675 21.4944L27.0124 21.6524",
    fill: "#BF96FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5977 21.5522L21.1878 22.0264L21.1663 22.3785L21.5615 22.0048L21.3604 22.0264L21.1663 22.3785L21.3604 22.0264H21.1878H21.3604L21.5977 21.5522Z",
    fill: "#BF96FF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5615 22.0054L21.3604 22.0269L21.1663 22.379L21.5615 22.0054Z",
    fill: "#BF96FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5615 22.0048L21.5977 21.5522L21.3604 22.0264H21.1878L21.1663 22.3785L21.3604 22.0264L21.5615 22.0048Z",
    fill: "#BF96FF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5971 21.5524L21.1877 22.0265H21.3603C21.3603 22.0265 21.5971 21.5435 21.5971 21.5524Z",
    fill: "#BF96FF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6444 31.9126L19.5994 31.6426L19.4765 31.6499L20.6444 31.9126Z",
    fill: "#BF96FF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3884 30.9756L19.4631 30.4062L19.2455 30.9471L19.3884 30.9756L19.5999 31.6443L19.477 31.6516L19.2455 30.9471",
    fill: "#BF96FF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5999 31.6443L19.4631 30.4062L19.3884 30.9756L19.2455 30.9471L19.477 31.6516L20.6449 31.9143L20.4072 31.5969L19.8306 30.6281L19.4631 30.4062L20.4072 31.5969L19.5999 31.6443L20.6449 31.9143Z",
    fill: "#BF96FF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5999 31.6445L19.3884 30.9758L19.2455 30.9473L19.477 31.6518L19.5999 31.6445Z",
    fill: "#BF96FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3867 30.9756L19.5981 31.6443L20.4055 31.5969L19.4614 30.4062L19.3867 30.9756Z",
    fill: "#BF96FF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3884 30.9758L19.5999 31.6445L19.477 31.6518L19.2455 30.9473L19.3884 30.9758Z",
    fill: "#BF96FF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4063 31.5957L20.3536 31.8376L20.644 31.9131",
    fill: "#BF96FF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8152 30.1438L24.5841 29.0518L23.3484 30.1006L23.8152 30.1438L25.4246 30.1584L25.8125 30.0074L24.5841 29.0518L23.3484 30.1006L23.8152 30.1438L24.6272 32.0047L23.3484 30.1006L24.5841 29.0518L23.8152 30.1438Z",
    fill: "#BF96FF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6266 32.0047L23.8146 30.1438L25.424 30.1584L23.8146 30.1438L24.5835 29.0518L25.424 30.1584L24.6266 32.0047L25.8119 30.0074L24.6266 32.0047Z",
    fill: "#BF96FF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6266 32.0039L23.8146 30.1431L25.424 30.1577L24.6266 32.0039Z",
    fill: "#BF96FF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5848 29.0518L25.4253 30.1584L25.8132 30.0074L24.5848 29.0518Z",
    fill: "#BF96FF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8152 30.1438L24.5841 29.0518L23.3484 30.1006L24.5841 29.0518L23.3484 30.1006L23.8152 30.1438L24.5841 29.0518L25.4246 30.1584L25.8125 30.0074L24.6272 32.0047L25.4246 30.1584L23.8152 30.1438Z",
    fill: "#BF96FF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3483 30.1001L23.8152 30.1432L24.6272 32.0041L23.3483 30.1001Z",
    fill: "#BF96FF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5841 29.0518L23.8152 30.1438L23.3484 30.1006L24.5841 29.0518Z",
    fill: "#BF96FF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5382 29.5286L21.4612 28.9751L21.732 29.9019L22.5382 29.5286Z",
    fill: "#BF96FF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0759 28.6069L21.4849 29.8889L21.7319 29.9008L21.4611 28.974L21.0759 28.6069Z",
    fill: "#BF96FF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4611 28.974L22.5381 29.5276L22.6224 29.3712L21.0759 28.6069L21.4611 28.974Z",
    fill: "#BF96FF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7305 29.9001L23.0243 30.7067L22.5367 29.5269L21.7305 29.9001Z",
    fill: "#BF96FF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M23.334 31.0015L22.624 29.3706L23.334 31.0015L21.4866 29.8883L21.7335 29.9002L23.0273 30.7068L23.334 31.0015L23.0273 30.7068Z",
    fill: "#BF96FF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0759 28.6069L21.4849 29.8889L21.7319 29.9008L21.4611 28.974L21.0759 28.6069Z",
    fill: "#BF96FF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6238 29.3706L22.5394 29.527L23.0271 30.7068L23.3337 31.0015L22.6238 29.3706Z",
    fill: "#BF96FF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7527 25.0371L29.7828 27.8471L30.6915 26.7755L30.7019 26.7636L30.4122 26.398L30.5674 26.0386L30.3209 25.5078L29.8722 25.1939L29.7527 25.0371Z",
    fill: "#BF96FF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8725 25.1929L30.4125 26.397L30.3212 25.5068",
    fill: "#BF96FF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5673 26.0381L30.6347 26.2322L30.7017 26.763L30.4121 26.3975L29.7827 27.8466L30.7017 26.763L30.5673 26.0381Z",
    fill: "#BF96FF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4116 26.3975L30.5669 26.0381L30.7013 26.763",
    fill: "#BF96FF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7527 25.0371L30.0628 26.4496L29.7828 27.8471L29.7527 25.0371Z",
    fill: "#BF96FF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0628 26.4496L29.7639 26.3522L29.7527 25.0371L30.0628 26.4496Z",
    fill: "#BF96FF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0669 29.4756L29.7742 31.3049L30.8616 31.0372L30.8739 31.0341L30.8573 30.6628L31.1254 30.5029L31.214 30.0449L31.0707 29.6327L31.0669 29.4756Z",
    fill: "#BF96FF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M31.07 29.6313L30.8566 30.6614L31.2133 30.0435",
    fill: "#BF96FF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1254 30.502L31.0781 30.6587L30.8739 31.0331L30.8573 30.6618L29.7742 31.3039L30.8739 31.0331L31.1254 30.502Z",
    fill: "#BF96FF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8565 30.6618L31.1246 30.502L30.8731 31.0331",
    fill: "#BF96FF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0669 29.4756L30.6077 30.5329L29.7742 31.3049L31.0669 29.4756Z",
    fill: "#BF96FF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6066 30.5329L30.4587 30.3307L31.0657 29.4756L30.6066 30.5329Z",
    fill: "#BF96FF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2581 33.6147L23.3957 33.9884L22.9935 35.0014L23.688 34.3759L24.2581 33.6147Z",
    fill: "#BF96FF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M23.688 34.3759L24.2581 33.6147L23.3957 33.9884L23.688 34.3759L22.9935 35.0018L24.0135 34.5708",
    fill: "#BF96FF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M24.012 34.57L23.6865 34.3751L24.2565 33.6147L24.012 34.57L23.6865 34.3751Z",
    fill: "#BF96FF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2861 33.9956L26.9313 34.2182L26.845 34.4555L25.3435 34.2256L25.2861 33.9956Z",
    fill: "#BF96FF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M27.031 33.8096L26.9305 34.219L25.2853 33.9964L24.6744 33.8385L27.031 33.8096Z",
    fill: "#BF96FF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3424 34.2247L25.285 33.9947L26.9302 34.2173L26.8439 34.4546L26.9302 34.2173L28.5322 33.9015L26.8439 34.4546L25.3424 34.2247L24.6741 33.8368L25.285 33.9947L24.6741 33.8368L27.3754 33.3984L27.0307 33.8079L26.9302 34.2173L27.0307 33.8079L28.5322 33.9015L27.3754 33.3984L27.0307 33.8079L24.6741 33.8368",
    fill: "#BF96FF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5307 33.9027L27.0292 33.8091L26.9287 34.2185L28.5307 33.9027Z",
    fill: "#BF96FF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M27.031 33.8079L27.3757 33.3984L24.6744 33.8368L27.031 33.8079Z",
    fill: "#BF96FF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0494 33.9661L24.2176 33.4342L21.0994 33.4273L20.8479 32.2778L19.1384 32.7015L21.0994 33.4273L21.0494 33.9661L19.1384 32.7015L20.8479 32.2778L23.0682 32.7231L24.2176 33.4342L21.0494 33.9661L24.2176 33.4342L21.0994 33.4273L20.8479 32.2778L19.1384 32.7015L21.0494 33.9661L21.0994 33.4273L19.1384 32.7015",
    fill: "#BF96FF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M24.219 33.4332L21.0508 33.9651L21.1009 33.4263L24.219 33.4332Z",
    fill: "#BF96FF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8479 32.2778L21.0994 33.4273L19.1384 32.7015L20.8479 32.2778Z",
    fill: "#BF96FF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M23.07 32.7231L20.8498 32.2778L21.1013 33.4273",
    fill: "#BF96FF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3775 31.1029L28.9965 31.2662L28.7126 31.1302L30.0173 29.9292",
    fill: "#BF96FF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8302 32.8613L28.0913 30.6268L30.0161 29.9292L29.359 31.5786L29.3763 31.1029L30.0161 29.9292L28.7115 31.1302L28.0913 30.6268L30.0161 29.9292L28.7115 31.1302L28.0913 30.6268",
    fill: "#BF96FF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8302 32.8605L28.304 32.389L27.9631 32.3497L28.304 32.389L29.359 31.5778L28.9954 31.2654L27.9631 32.3497L26.8302 32.8605L28.0913 30.626L28.7115 31.1294L26.8302 32.8605Z",
    fill: "#BF96FF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3763 31.1035L28.9954 31.2668L29.359 31.5792L29.3763 31.1035Z",
    fill: "#BF96FF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9634 32.3516L28.9957 31.2673L28.7119 31.1313L26.8306 32.8624L27.9634 32.3516Z",
    fill: "#BF96FF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 31.535L27.1405 30.5581L26.9394 31.8801L25.6031 31.535Z",
    fill: "#BF96FF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6022 31.535L24.8118 33.2163L26.1553 32.8354L26.9384 31.8801L27.2832 31.8512L27.1395 30.5581L25.6022 31.535Z",
    fill: "#BF96FF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3995 32.9132L26.1553 32.8343L26.9384 31.879L27.2832 31.8501L26.3995 32.9132L24.8118 33.2152L26.1553 32.8343L26.3995 32.9132Z",
    fill: "#BF96FF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9394 31.8801L25.6031 31.535L27.1405 30.5581L26.9394 31.8801Z",
    fill: "#BF96FF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3994 32.913L26.1552 32.834L24.8116 33.2149L26.3994 32.913Z",
    fill: "#BF96FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_221_35104",
    x1: -3.63703,
    y1: 2.93836,
    x2: 32.2303,
    y2: 27.3147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F1EFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C7C2CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A198A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#817587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#66576E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#503E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3E2C48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#331E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2C1736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A1535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_221_35104",
    x1: 25.3563,
    y1: 0,
    x2: 25.3563,
    y2: 44.9864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_221_35104",
    x1: 25.355,
    y1: 28.6275,
    x2: 25.355,
    y2: 44.9831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_221_35104",
    x1: 25.355,
    y1: 44.3247,
    x2: 25.355,
    y2: 0.658671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_221_35104",
    x1: 25.3533,
    y1: 16.3555,
    x2: 25.3533,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACBCDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_221_35104",
    x1: 8.11812,
    y1: 22.1084,
    x2: 8.11812,
    y2: 29.4435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_221_35104",
    x1: 4.41493,
    y1: 6.52851,
    x2: 10.4274,
    y2: 9.74684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85769C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_221_35104",
    x1: 10.5847,
    y1: 10.7754,
    x2: 5.25505,
    y2: 7.92252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_221_35104",
    x1: 11.8386,
    y1: 5.17147,
    x2: 9.93167,
    y2: 4.15075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_221_35104",
    x1: 10.143,
    y1: 2.17159,
    x2: 11.7251,
    y2: 3.01845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACBCDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_221_35104",
    x1: 15.4382,
    y1: 6.67416,
    x2: 13.4742,
    y2: 5.62285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_221_35104",
    x1: 6.11307,
    y1: 13.5009,
    x2: 6.57326,
    y2: 13.7473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_221_35104",
    x1: 1.6491,
    y1: 19.5231,
    x2: 0.151376,
    y2: 22.4845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_221_35104",
    x1: 4.49551,
    y1: 38.3076,
    x2: 10.508,
    y2: 35.0893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85769C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_221_35104",
    x1: 10.6696,
    y1: 34.0624,
    x2: 5.33685,
    y2: 36.9168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_221_35104",
    x1: 11.965,
    y1: 39.6391,
    x2: 9.9979,
    y2: 40.6921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_221_35104",
    x1: 10.2266,
    y1: 42.6639,
    x2: 11.8087,
    y2: 41.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_221_35104",
    x1: 15.3208,
    y1: 38.1162,
    x2: 13.3898,
    y2: 39.1498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_221_35104",
    x1: 6.19368,
    y1: 31.3361,
    x2: 6.65678,
    y2: 31.0882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_221_35104",
    x1: -0.0631841,
    y1: 27.9294,
    x2: 2.03841,
    y2: 26.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_221_35104",
    x1: 6.63883,
    y1: 24.4081,
    x2: 1.03686,
    y2: 20.4608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85769C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_221_35104",
    x1: 3.68704,
    y1: 19.8631,
    x2: 3.68704,
    y2: 24.6497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_221_35104",
    x1: 3.69045,
    y1: 7.17515,
    x2: 3.69045,
    y2: 11.9617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_221_35104",
    x1: 42.5897,
    y1: 22.1084,
    x2: 42.5897,
    y2: 29.4435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_221_35104",
    x1: 46.1902,
    y1: 6.56275,
    x2: 40.1777,
    y2: 9.78113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85769C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_221_35104",
    x1: 40.0219,
    y1: 10.8112,
    x2: 45.3517,
    y2: 7.95834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_221_35104",
    x1: 38.7716,
    y1: 5.20732,
    x2: 40.6786,
    y2: 4.18655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_221_35104",
    x1: 40.4657,
    y1: 2.20686,
    x2: 38.8835,
    y2: 3.05376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACBCDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_221_35104",
    x1: 32.4809,
    y1: 6.36687,
    x2: 40.5051,
    y2: 4.16975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_221_35104",
    x1: 44.4966,
    y1: 13.5366,
    x2: 44.0365,
    y2: 13.7829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_221_35104",
    x1: 49.0546,
    y1: 19.5223,
    x2: 50.5524,
    y2: 22.4836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_221_35104",
    x1: 46.1134,
    y1: 38.2752,
    x2: 40.101,
    y2: 35.0569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85769C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_221_35104",
    x1: 39.9407,
    y1: 34.0278,
    x2: 45.2734,
    y2: 36.8822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_221_35104",
    x1: 38.6488,
    y1: 39.6059,
    x2: 40.6128,
    y2: 40.6572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_221_35104",
    x1: 40.3859,
    y1: 42.6291,
    x2: 38.8037,
    y2: 41.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_221_35104",
    x1: 35.2926,
    y1: 38.083,
    x2: 37.2205,
    y2: 39.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_221_35104",
    x1: 44.4165,
    y1: 31.3013,
    x2: 43.9534,
    y2: 31.0533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_221_35104",
    x1: 50.7704,
    y1: 27.9283,
    x2: 48.6689,
    y2: 26.3999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_221_35104",
    x1: 44.0669,
    y1: 24.4083,
    x2: 49.6721,
    y2: 20.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85769C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_221_35104",
    x1: 47.0133,
    y1: 19.8636,
    x2: 47.0133,
    y2: 24.6502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_221_35104",
    x1: 47.0126,
    y1: 7.17515,
    x2: 47.0126,
    y2: 11.9617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcanaElement);
export default __webpack_public_path__ + "static/media/arcana-element.448a8f24f9d71bf86077c5b337116d95.svg";
export { ForwardRef as ReactComponent };